<template>
    <div class="basic_wrap">
        <van-nav-bar
                safe-area-inset-top
                fixed
                :title="$t('lang.量化产品')"
                left-arrow
                @click-left="$router.back()"
        />

        <div class="box">
            <div class="tab">
                <div class="tab-item" :class="{ 'active': curTabIndex === 0 }"  @click="tabChange(0)">{{  $t('item.all') }}</div>
                <div class="tab-item" :class="{ 'active': curTabIndex === item.id }" v-for="(item,index) in classList" @click="tabChange(item.id)">{{ item[lang] }}</div>
            </div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :loading-text="$t('lang.加载中')"
                    :finished-text="$t('lang.没有更多了')"
                    @load="getProjectList"
            >
                <div class="main main-border" v-if="curTabIndex === 0">
                    <HomeReginSmallItem
                            v-for="(item,index) in list"
                            @click="$router.push('/item/' + item.id)"
                            :key="item.id"
                            :name="item[lang]"
                            :vip="item.user_member"
                            :rate="item.rate"
                            :day="item.day"
                            :amount="parseInt(item.max)"
							:logo="item.img"
                            :used="item.used"
                            :total="item.num"
                            :percent="item.percent"
                            :ms="item.sy_ms"
                    />
                </div>
                <div class="main2" :class="{ 'main-border': listLength > 0 }" v-else>
				
				
                    <HomeReginBigItem
                            v-for="(item,index) in list"
                            @click="$router.push('/item/' + item.id)"
                            :key="item.id"
                            :name="item[lang]"
                            :rate="item.rate"
                            :day="item.day"
                            :amount="parseInt(item.max)"
							:logo="item.img"
                            :used="item.used"
                            :total="item.num"
                            :percent="item.percent"
                            :ms="item.sy_ms"
                    />
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import HomeReginSmallItem from '@/components/HomeRegionItem/small.vue'
import HomeReginBigItem from '@/components/HomeRegionItem/big.vue'
import Fetch from '@/utils/fetch';

export default {
    components: {
        HomeReginSmallItem,
        HomeReginBigItem
    },
    name: "indexNew",
    data() {
        return {
            lang: this.$i18n.locale || "en_us",
            loading: true,
            finished: false,
            curTabIndex: 0,
            tabs: [
                this.$t('item.all'),
                this.$t('item.tab1'),
                this.$t('item.tab2'),
                this.$t('item.tab3'),
                this.$t('item.tab4'),
                this.$t('item.tab5'),
            ],
            list: [],
            listLength: [],
            classList: []
        }
    },
    created() {
        this.$parent.footer('itemNew', true);
        if(this.$route.query.type){
            this.curTabIndex = parseInt(this.$route.query.type)
        }
        this.getClass();
        this.getProjectList();
    },
    methods: {
        tabChange(index){
          this.curTabIndex=index;
          this.getProjectList();
        },
        getClass(){
            Fetch('/index/item_class').then(r => {
                this.classList = r.data.list.reverse();
            })
        },
        getProjectList() {
            Fetch('/index/item_search', {
                name: "",
                index_type: this.curTabIndex
            }).then(r => {
                this.list = r.data.list;
                this.listLength = r.data.list.length;
                this.finished = true
            })
        }
    }
}
</script>

<style scoped lang="less">
/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}

.tab::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.tab {
  width: 100%;
  height: 55px;
  overflow-x: scroll;
  overflow-y: visible;
  white-space: nowrap;

  .active {
    color: rgb(70, 44, 26) !important;
    background: linear-gradient(0deg, rgb(182, 145, 117) 0%, rgb(244, 222, 201) 100%) !important;
  }

  .tab-item {
    display: inline-block;
    width: auto;
    box-sizing: border-box;
    height: 44px;
    line-height: 44px;
    border-radius: 0.15rem 0.15rem 0 0;
    border: 1.5px solid rgb(239, 216, 196);
    padding: 0.05rem 0.3rem;
    background: #231D1D;
    color: rgb(152, 135, 128);
    font-size: .8rem;
    text-align: center;
  }
}

.main-border{
  border: 2px solid;
  -o-border-image: linear-gradient(0deg, #4D3A29, #C5B4A0) 10 10;
  border-image: linear-gradient(0deg, #4D3A29, #C5B4A0) 10 10;
}
.main {
  padding: .3rem;
  display: grid;
  grid-template-columns: repeat(2, 47%);
  grid-gap: 20px;
}
.main2 {
  padding: .3rem;
}

.basic_wrap {
  padding-top: 46px;
  display: flex;
  height: 100vh;
  box-sizing: border-box;
  flex-direction: column;

  .box {
    //overflow: hidden;
    flex: 1;
    background: url(../../assets/img/home-bg.jpg) no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: .3rem
  }
}

</style>
